
//View switcher
(function($) { "use strict";

	// console.log('include view switcher')

	//Clicked View as Columns (slick carousel)
	$(".icon-view-columns").unbind().click(function(element) {
		// console.log('clicked icon-view-columns');
		
		$(".icon-view-list").removeClass("js-active"); //Deactivate List icon
		$(this).addClass("js-active"); //Activate Columns icon

		$(this).closest('.js-view-switch')
			.removeClass('js-view-list')
			.addClass('js-view-column')
		;

		// $(".tease__column-view").removeClass("js-hidden"); //Show Columns view
		// $(".tease__list-view").addClass("js-hidden"); //Hide List view
		// $(".tease__column-view").parent().addClass("js-view-column"); //Show Columns view
		// $(".tease__list-view").parent().removeClass("js-view-list"); //Hide List view

		// console.log('activate carousel');
		$('.js-tease-slider').trigger('activate-carousel');
		
	});
	
	//Clicked View as List
	$(".icon-view-list").unbind().click(function() {
		// console.log('clicked icon-view-list');
		$(".icon-view-columns").removeClass("js-active"); //Deactivate Columns icon
		$(this).addClass("js-active"); //Activate List icon

		$(this).closest('.js-view-switch')
			.removeClass('js-view-column')
			.addClass('js-view-list')
		;
		// $(".tease__list-view").removeClass("js-hidden"); //Show List view
		// $(".tease__column-view").addClass("js-hidden"); //Hide Columns view
		// $(".tease__column-view").parent().removeClass("js-view-column"); //Hide Columns view
		// $(".tease__list-view").parent().addClass("js-view-list"); //Show List view

		// console.log('deactivate carousel');
		$('.js-tease-slider').trigger('deactivate-carousel');
	});
	
	

})(jQuery);